import React, { useEffect, createElement } from 'react';
import { AnnouncementBanner } from './components/AnnouncementBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { VendorLogos } from './components/VendorLogos';
import { FeatureCards } from './components/FeatureCards';
import { HowItWorks } from './components/HowItWorks';
import { ModelShowcase } from './components/ModelShowcase';
import { PricingPreview } from './components/PricingPreview';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'OpenFPGA — The Unified Interface for FPGA Inference';
    // Set meta description for link previews
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Better latency, better power efficiency, no vendor lock-in. Access the world's most powerful programmable hardware through a single API.";
    // Set Open Graph tags for rich link previews
    const ogTags: Record<string, string> = {
      'og:title': 'OpenFPGA — The Unified Interface for FPGA Inference',
      'og:description': "Better latency, better power efficiency, no vendor lock-in. Access the world's most powerful programmable hardware through a single API.",
      'og:type': 'website',
      'og:url': 'https://openfpga.ai',
      'og:site_name': 'OpenFPGA'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <div className="min-h-screen bg-gate-dark text-gate-text-primary font-sans selection:bg-gate-teal/30 selection:text-white" data-id="element-0">
      <AnnouncementBanner data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <StatsBar data-id="element-5" />
        <VendorLogos data-id="element-6" />
        <FeatureCards data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <ModelShowcase data-id="element-9" />
        <PricingPreview data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}